export default __webpack_public_path__ + "static/searchicon-f6cc5b8531db95b29e2fe643fbc82897.svg";